var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"alt":"How it works desktop","src":_vm.desktopImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }